import { Tooltip } from '@mantine/core'

import DNButton from 'src/components/Buttons/Button/DNButton'

const AutomatedRuleHeader = ({
  ruleName,
  isDisabled,
  isLoading,
  onRuleSubmit,
}) => {
  return (
    <div className="flex flex-row items-start justify-between text-sm font-medium">
      <div className="flex w-full flex-col gap-2">
        <div className="flex flex-row items-center justify-between gap-1">
          <div className="flex-1">{ruleName}</div>
          {/* Right side (Save button) */}
          <Tooltip
            label="Please make sure to have all required fields filled out before saving"
            disabled={!isDisabled}
            position="bottom"
            withArrow
            arrowPosition="center"
          >
            <DNButton
              variant="primary"
              className="w-[75px]"
              loading={isLoading}
              disabled={isDisabled}
              onClick={() => onRuleSubmit()}
            >
              Save
            </DNButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default AutomatedRuleHeader
